import type { DiagramSpec } from "../types"

/** Radial / hub-spoke — center system with connections radiating out */
export const radialDiagram: DiagramSpec = {
  id: "radial",
  name: "Radial: Brain Server Hub",
  description: "Hub-spoke layout showing what connects to brain-server",
  layers: [
    { id: "core", name: "Core", color: "#f59e0b" },
    { id: "input", name: "Inputs", color: "#6366f1" },
    { id: "output", name: "Services", color: "#10b981" },
  ],
  nodes: [
    // Center hub
    {
      id: "brain",
      label: "Brain Server",
      layer: "core",
      rank: 0,
      description: "Central orchestrator — routes messages to Claude Code",
    },

    // Inner ring — inputs
    { id: "telegram", label: "Telegram", layer: "input", rank: 1, description: "60+ chat groups via webhook" },
    { id: "slack", label: "Slack", layer: "input", rank: 1, description: "Workspace integration via Events API" },
    { id: "crons", label: "Cron Scheduler", layer: "input", rank: 1, description: "Time-based triggers every 60s" },
    { id: "email", label: "Gmail Router", layer: "input", rank: 1, description: "Email rules → CC spawn" },
    { id: "vapi", label: "Vapi Voice", layer: "input", rank: 1, description: "Voice call transcription" },
    { id: "dashboard", label: "Dashboard", layer: "input", rank: 1, description: "React SPA at /app/*" },

    // Outer ring — services
    { id: "cc", label: "Claude Code", layer: "output", rank: 2, description: "CLI subprocess with full repo access" },
    { id: "skills", label: "Skills Layer", layer: "output", rank: 2, description: "api-*, wf-*, engine-* skills" },
    { id: "sqlite", label: "SQLite", layer: "output", rank: 2, description: "brain.db — shared data store" },
    { id: "r2", label: "Cloudflare R2", layer: "output", rank: 2, description: "Image/file hosting CDN" },
    { id: "lcm", label: "LCM", layer: "output", rank: 2, description: "Lossless Context Management" },
    { id: "n8n", label: "n8n", layer: "output", rank: 2, description: "Workflow automation (legacy)" },
  ],
  edges: [
    { id: "e1", source: "telegram", target: "brain" },
    { id: "e2", source: "slack", target: "brain" },
    { id: "e3", source: "crons", target: "brain" },
    { id: "e4", source: "email", target: "brain" },
    { id: "e5", source: "vapi", target: "brain" },
    { id: "e6", source: "dashboard", target: "brain" },
    { id: "e7", source: "brain", target: "cc" },
    { id: "e8", source: "brain", target: "skills" },
    { id: "e9", source: "brain", target: "sqlite" },
    { id: "e10", source: "brain", target: "r2" },
    { id: "e11", source: "brain", target: "lcm" },
    { id: "e12", source: "brain", target: "n8n" },
  ],
  views: [{ id: "main", name: "Hub & Spoke", layout: "radial" }],
  defaultView: "main",
  preferences: {
    nodeWidth: 180,
    rankSpacing: 220,
    showLayerBands: false,
    edgeStyle: "bezier",
    edgeColor: "#4a6a8a",
  },
}
